<template>
  <div class="applicableEntrance">
    <div class="applicable-e">
      <ul>
        <template v-for="(item, homeIndex) in homeText.list">
          <li :key="homeIndex" v-if="item.imageUrls && item.imageUrls.length > 0">
            <img :src="BASE_URL + item.imageUrls" alt="" />
          </li>
        </template>
      </ul>
      <div class="convenient">{{ homeText.mainTitle }}</div>
      <div class="free" @click="goFreeTrial">
        <span> 免费试用 </span>
        <span class="arrow"></span>
      </div>
    </div>
    <img src="../../assets/huoimg.png" alt="" class="huopostile" />
  </div>
</template>

<script>
import { getConf } from "../../api/article";
export default {
  name: "enterConsultation",
  data() {
    return {
       BASE_URL: process.env.VUE_APP_API_BASE_URL,
       homeText:{list:[]},
    };
  },
   mounted() {
    this.fetchHomeConf();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        
        let parsedData = {};
        try{
          parsedData = JSON.parse(response.data.text);
          if (!parsedData || !Array.isArray(parsedData.list)) { 
            console.warn("接口返回数据格式异常或缺少 list 字段");
            parsedData = { list: [] }; // 保证不会报错且列表为空显示无内容状态。
          }
          
        }catch(e){
          console.error('JSON parse error:', e);
          parsedData={list:[]};
        }

        this.homeText=parsedData;

      } catch (error) {
        console.error("页面初始化获取配置失败", error);

      }
    },
    goFreeTrial() {
      this.$router.push({ name: "freeTrial" });
    },
  },
};
</script>
<style lang="scss" scoped>
.applicableEntrance {
  width: 100%;
  height: 497px;
  background: #eff4fb;
  position: relative;
  .applicable-e {
    width: 1320px;
    margin: 86px auto 0;
    ul {
      display: flex;
      justify-content: space-between;
      li {
        width: 300px;
        height: 217px;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          #f5f9ff 0%,
          #ffffff 100%
        );
        box-shadow: 0px 3px 20px 1px rgba(115, 154, 188, 0.16);
        border-radius: 8px;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        .icon-title-group {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }

        
      }
    }

    .call-to-action {
      text-align: center;
      margin-top: 40px;

      h2 {
        font-size: 24px;
        color: #000a25;
        margin-bottom: 24px;
      }

      .el-button {
        width: 120px;
        background-color: #0066ff;
        border-color: #0066ff;
      }
    }
  }
  .convenient {
    margin-top: 45px;
    font-weight: 400;
    font-size: 30px;
    color: #000a25;
    text-align: center;
  }
  .free {
    width: 160px;
    height: 48px;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px auto 0; // 水平居中
    cursor: pointer; /* 核心：hover 时变成手指指针 */
    transition: color 0.3s ease; /* 可选：颜色过渡动画，更流畅 */
    background: #005cef;
    box-shadow: 0px 6px 24px 1px rgba(0, 92, 239, 0.4);
    border-radius: 4px 4px 4px 4px;

    .arrow {
      width: 16px;
      height: 16px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      margin-left: 8px;
    }
  }
  .huopostile {
    width: 366px;
    height: 476px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>